import { AuthenticationProvider } from "@heidelbergmaterials/fcl-authclient"
import { ReactNode } from "react"

interface FcpAuthProviderProps {
	children: ReactNode
}

/**
 * FCP (Framework Component Library) Authentication Provider
 * Wraps the application with company-standard authentication using fcl-authclient
 *
 * This provider handles:
 * - OAuth 2.0 / OIDC authentication flow
 * - PKCE challenge generation
 * - Token management (access, refresh, ID tokens)
 * - Automatic token refresh
 * - LocalStorage-based token persistence
 * - Redirect handling for login/logout
 */
export const FcpAuthProvider: React.FC<FcpAuthProviderProps> = ({
	children,
}) => {
	const identityServerUrl = import.meta.env.VITE_AUTH_HCONNECT
	const clientId = "CarbonBank"
	const redirectUri = `${globalThis.location.origin}/`
	const authRedirectUri = `${globalThis.location.origin}/auth`
	const postLogoutUri = `${globalThis.location.origin}/auth/callback/logout`

	// Identity provider slug in snake_case format (e.g., "mhc", "entra", "custom_idp")
	// This determines which identity provider to use for authentication
	const identityProvider = "mhc"

	return (
		<AuthenticationProvider
			clientId={clientId}
			identityProvider={identityProvider}
			identityServerUrl={identityServerUrl}
			authRedirectUri={authRedirectUri}
			redirectUri={redirectUri}
			oauthScopes="global openid offline_access"
			postLogoutUri={postLogoutUri}
			autoRedirect={false}
		>
			{children}
		</AuthenticationProvider>
	)
}
